import {combineReducers} from "redux";

import * as Validations from "./validations";
import * as Configurations from "./configuration";

export default combineReducers({
    validations: Validations.reducer,
    configuration: Configurations.reducer,
});
